import { useEffect, useState } from 'react';

import { Modal, TextField } from '@atom/mui';

import { validateFolderName } from './filesTabUtilities';

type EditMediaFolderModalProps = {
  open: boolean;
  folderId: string;
  initialName: string;
  onEdit: (folderId: string, name: string) => void;
  closeModal: () => void;
};

const EditMediaFolderModal = ({
  open,
  folderId,
  initialName,
  onEdit,
  closeModal,
}: EditMediaFolderModalProps) => {
  const [name, setName] = useState<string>(initialName ?? '');

  useEffect(() => {
    if (open) {
      setName(initialName ?? '');
    }
  }, [open, initialName]);

  const errorText = validateFolderName(name);

  const handleConfirm = () => {
    onEdit(folderId, name);
    closeModal();
  };

  return (
    <Modal
      open={open}
      title="Rename Folder"
      confirmButtonText="Save"
      onConfirm={handleConfirm}
      onCancel={closeModal}
      disabled={errorText.length > 0}
      CancelButtonProps={{ 'data-cy': 'filesTabEditFolderCancel' }}
      ConfirmButtonProps={{ 'data-cy': 'filesTabEditFolderConfirm' }}
    >
      <TextField
        label="Folder Name"
        name="name"
        value={name}
        autoFocus
        error={errorText.length > 0}
        helperText={errorText}
        onChange={event => setName(event.target.value)}
        data-cy="filesTabEditFolderNameInput"
      />
    </Modal>
  );
};

export default EditMediaFolderModal;
